import { getLink } from '../../../utils/utils';

import author from './author';

const content = {
  esp: (
    `
    <p class="mb-3">
      Jam delonge tio estis.
    </p>
    
    <p class="mb-3">
      Tiel antaŭdelonge, ke eĉ praavoj ne memoras tion.
    </p>
    
    <p class="mb-3">
      Nur rapsodoj kantas pri tio en siaj senfinaj, buntaj, longevolvantaj historioj.
    </p>
    
    
    <p class="mb-3">
      Iam estis sur la Tero la Paradizo; kaj nun forestas ĝi, eĉ la lokon oni ne scias… oni diras, ie en Kaŭkazio. 
      Iam estis sur la Tero la Paradizo, kun fluantaj akvoj, verdantaj arboj, kaj petaloj petolis kun la vento. 
      Iam brilantaj rosoj kovris la herbaron, kaj tiuj rosoj estis mielo, kaj homoj sin nutris per ĝi. 
      Akvon klaran-dolĉan ili trinkis, vestis sin en araneaĵon kaj la tutan tagon pasigis inter floroj, sur verda herbejo. 
      Suno brilis karese, varmigante ilin per radioj…
    </p>
    
    <p class="mb-3">
      Iam delonge tio estis.
    </p>
    
    <p class="mb-3">
      Nun, kiam furioze ĵetas la Suno siajn sagojn al la homar’; kiam velkas ĵusnaskitaj ĝermoj; kiam tondroj faligas surteren flamon, kaj tiu flamo devoras ĉion – nun tiuj, kiuj saviĝis, des pli petas rakontojn pri la pasint’… 
      Neniu jam kredas tion, eĉ ne perceptas serioze – sed tamen, foj-de-foje, ni reaŭskultas niajn rememorojn, nian pasinton.
    </p>
    
    <p class="mb-3">
      Iam. En la Paradizo…
    </p>
    
    <p class="mb-3">
      Nun neniu pensas pri tiu virino, kiu deŝiris la Frukton de la arbo. 
      Ja ĉiuj ni estas ŝiaj posteuloj. 
      Ŝia peko jam delonge estas forgesita…
    </p>
    
    <p class="mb-3">
      Sed neniam forgesos ŝin tiuj, de kies arbo ŝi deŝiris la frukton. 
      Kun malbenoj kaj krioj ili primemoras Tiun, kiu difektis la ŝipon, lasinte ilin por ĉiam sur la fremda kaj malamata planedo.
    </p>
    
    <p class="mb-3">
      Nur du bestojn ili protektis kontraŭ la granda fajrego, nuliginta ĉion surtere.
    </p>
    
    
    <p class="mb-3">
      Verdire, la kaŭzo de la fajrego estis ilia propra alveno, sed ĉu gravas? 
      Tiuj planedetoj kun primitiva vivo abundegas en la Kosmo.
    </p>
    
    
    <p class="mb-3">
      Malgraŭ tio, ili bonintence deponis du aborigenojn en sia ŝipo por delasi ilin reen post la brulego. 
    </p>
    
    
    <p class="mb-3">
      Kaj tiuj sencerbaj bestaĉoj faris ĝuste tion, kio estis por ili strikte malpermesita: alvenis al nia ĉefa Movilo kaj por ĉiam neniigis ĝin.
    </p>
    
    <p class="mb-3">
      Ho, ne unu pometon ili prenis, kiel oni idilie prikantis al siaj nepoj, sed la tutan arbon dishakis – sovaĝe, furioze, kvazaŭ komprenante, ke ili povas venĝi al siaj mastroj pro ilia komforta, senzorga vivo…
    </p>
    
    <p class="mb-3">
      Ni restis.
    </p>
    
    <p class="mb-3">
      Sen protekto de la jam delonge putriĝinta ŝipo, ni intermiksiĝis kun la gefiloj de tiuj du homoj; dekomence ni estis ege pli multnombraj, ol tiuj du, sed pro malbonaj kondiĉoj, multaj el ni pereis, kaj baldaŭ ili superis nin laŭ la nombro.
    </p>
    
    <p class="mb-3">
      Hodiaŭ ni loĝas inter ili, aŭskultas iliajn kantojn, kaj nur mensogon aŭdas, nur malveron.
    </p>
    
    <p class="mb-3">
      Ekstere ni aspektas same kiel ili, sed ni ĉiam sentas unu la alian; kaj ankaŭ ili per sia animala flaro sentas la niagentan anon, kaj ni malamas unu la alian reciproke.
    </p>
    
    <p class="mb-3">
      Ni havis komunan ligilreton: kiam al unu el ni estis solece aŭ triste, ni interligiĝis kaj agis kune.
    </p>
    
    <p class="mb-3">
      Sed nun tiom da jarcentoj pasis…
    </p>
    
    <p class="mb-3">
      Ni perdiĝis…
    </p>
    
    <p class="mb-3">
      Nun jam delonge mi estas sola, kaj al miaj alvokoj reehas neniu. 
      Eble, ĉiuj miaj parencoj nuliĝis, dissolviĝis en la amaso de la bestoj, la senĉese kreskanta amaso? 
      Mi ĉiutage rigardas al iliaj vizaĝoj, - ne, ili estas fremdaj al mi. 
      En iliaj okuloj – nenio, krom avido kaj malamo. 
      Verŝajne, mi restis sola… 
      Mi aŭskultas iliajn rapsodojn, kaj primemoras la Paradizon, nian belan Paradizon, kie tiel diafane fluantis la akvoj kaj la flava suno varmigis la roson de folioj.
    </p>
    
    <p class="mb-3">
      Mi rememoras pri multaj el ni – saĝaj, belaj, fieraj. 
      Mi kredas je nia spirito, kiu savos nin de la Tero, kaj ni daŭrigos nian vojon – por la Scienco, la Racio, la Intelekto. 
      Ĝi ja ne povas perfidi, ĝi savos nin!
    </p>
    
    <p class="mb-3">
      Kiel delonge tio estis…
    </p>
    `
  )
}

const itemName = {
  esp: 'Solulo'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemAuthor: author.esp
  }
}

export default item;

